import React, { ElementType } from 'react';

type props = {
    Icon: ElementType;
    label: string;
    onClick?: () => any;
}

function NavItem({Icon, label, onClick = () => null}: props): React.ReactElement {

    return (
    <>
        <div className='nav-item'>
            <Icon/>
            <button onClick={onClick}>
            {label}
            </button>
        </div>
    </>
    );
};

export default NavItem;